[
    {
        "userId": "27",
        "subscriptions": [
            {
                "type": ["digital+"],
                "weekday": null,
                "edition": null,
                "magazine": null,
                "start": "2024-08-03",
                "end": "2024-12-03"
            }
        ]
    },
    {
        "userId": "2",
        "subscriptions": [
            {
                "type": ["digital+"],
                "start": "2024-08-03",
                "end": "2024-09-21"
            }
        ]
    },
    {
        "userId": "3",
        "subscriptions": [
            {
                "type": ["epaper"],
                "edition": [
                    "DLZ",
                    "BZ",
                    "DK",
                    "MZ"
                ],
                "start": "2024-08-03",
                "end": "2024-11-21"
            },
            {
                "type": ["epaper"],
                "edition": [
                    "DLZ",
                    "BZ",
                    "DK",
                    "MZ"
                ],
                "start": "2024-08-03",
                "end": "2024-02-05"
            },
            {
                "type": ["epaper"],
                "edition": [
                    "DLZ",
                    "BZ",
                    "DK",
                    "MZ"
                ],
                "start": "2024-08-03",
                "end": "2024-06-13"
            },
            {
                "type": ["epaper"],
                "edition": [
                    "DLZ",
                    "BZ",
                    "DK",
                    "MZ"
                ],
                "start": "2024-08-03",
                "end": "2024-11-01"
            }
        ]
    },
    {
        "userId": "4",
        "subscriptions": []
    },
    {
        "userId": "5",
        "subscriptions": [
            {
                "type": ["einzelausgabe"],
                "edition": [
                    "DLZ"
                ],
                "magazine": "20240920"
            },
            {
                "type": ["einzelausgabe"],
                "edition": [
                    "DLZ"
                ],
                "magazine": "20240923"
            }
        ]
    },
    {
        "userId": "6",
        "subscriptions": [
            {
                "type": ["digital+"],
                "start": "2024-01-03",
                "end": "2024-08-03"
            }
        ]
    }
]